import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center text-black text-lg" }
const _hoisted_2 = { class: "modalscrollable" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white",
  for: "file_input"
}, null, -1)
const _hoisted_4 = ["accept"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_7 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_8 = { for: "date" }
const _hoisted_9 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_10 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_11 = { class: "w-full mt-2" }
const _hoisted_12 = {
  for: "type",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_13 = {
  disabled: "",
  value: ""
}
const _hoisted_14 = {
  key: 0,
  value: "foto"
}
const _hoisted_15 = {
  key: 1,
  value: "Video"
}
const _hoisted_16 = {
  key: 2,
  value: "registrazione"
}
const _hoisted_17 = {
  key: 3,
  value: "esamistrumentali"
}
const _hoisted_18 = {
  key: 4,
  value: "dicom"
}
const _hoisted_19 = {
  key: 5,
  value: "documento"
}
const _hoisted_20 = {
  key: 6,
  value: "kardia"
}
const _hoisted_21 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_22 = { style: {"margin-top":"2%"} }
const _hoisted_23 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_24 = { style: {"margin-top":"2%"} }
const _hoisted_25 = {
  key: 0,
  for: "confidenzialità"
}
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "text-red-500 mb-2 w-full" }
const _hoisted_28 = { class: "flex justify-between" }

import { File, TagMedicalSpecialty } from "@/../../EshJSLib/models/patient";
import { patientStore } from "@/store/patient";
import { storeToRefs } from "pinia";
import { ref, computed, onMounted, reactive } from "vue";
import { Modal, Input } from "flowbite-vue";
import { CollapsableModel } from "@/../../EshJSLib/models/CollapsableModel";


export default /*#__PURE__*/_defineComponent({
  __name: 'modal_addnewfile',
  props: {
    schema: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const store = patientStore();
const { patient } = storeToRefs(store);

const alertConfirmMessage = ref<null | string>(null);
let resolvePromise: (value: PromiseLike<boolean> | boolean) => void;
const modalType = ref<"confirm" | "alert">("confirm");
const trueBtnText = computed(() =>
  modalType.value === "confirm" ? "Yes" : "Okay"
);
const falseBtnText = ref("No");
const showConfirm = ref(false);
let row = ref({} as File);
const mandatoryFields = ['file', 'data_rilievo', 'type'];
let errors = ref([]);
let errorMessage = "Questo campo è obbligatorio!";



function openModal(message: string, file: any, alertModal: boolean) {
  alertConfirmMessage.value = message;
  filenew.value = file;
  alertModal ? (modalType.value = "alert") : (modalType.value = "confirm");
  showConfirm.value = true;
  return new Promise((resolve) => {
    resolvePromise = resolve;
  });
}

function handleUserInput(value: boolean) {
  if(!value) {
    resolvePromise(value);
    showConfirm.value = false;
    return;
  }
  if (!validateFields()) {
    return;
  }
  if (!resolvePromise) return;
  resolvePromise(value);
  showConfirm.value = false;
}

function checkAll($event) {
  if ($event.target.checked) {
      filenew.value.tags = tagsToArray();
    } else {
      filenew.value.tags = [];
    }
}

function tagsToArray() {
  let tagsArray = []; let i = 0;
  for(let tag of patient.value.tag_medical_specialties) {
    tagsArray[i++] = tag.id;
  }
  console.log(tagsArray);
  return tagsArray;
}

function checkTag($event, tag: TagMedicalSpecialty) {
    let tagArray = [];
    if (filenew.value.tags.length != 0) {
      tagArray = filenew.value.tags;
    }
    if ($event.target.checked) {
      tagArray = tagArray.concat(tag.id);
    } else {
      tagArray = tagArray.filter(taga => taga != tag.id);
    }
    filenew.value.tags = tagArray;
  }

const link = ref('');
const reader = new FileReader();
let filenew = ref({} as any);
let errorInvalidFile = ref('');

function readFile($event) {
  const file = $event.target.files[0];
  link.value = URL.createObjectURL(file);
  const blob = new Blob([file], { type: file.type });
  reader.readAsDataURL(blob);
  
  reader.onload = () => {
    filenew.value.file = reader.result;
  };

  filenew.value.file_nome = file.name;
  filenew.value.file_size = file.size / 1000000;
  filenew.value.file_type = file.type;

  const isPDFFile = file.type === 'application/pdf';
  
  if (props.schema === 'kardiasschema') {
    errorInvalidFile.value = isPDFFile ? '' : 'Seleziona un file PDF';
  } else {
    errorInvalidFile.value = '';
  }

  filenew.value.file = isPDFFile ? filenew.value.file : [];
}

function validateFields(): boolean {
  let hasError = false;
  errors.value = [];

  mandatoryFields.forEach((field) => {
    if (field === 'type') {
      if (!filenew.value.type || filenew.value.type.trim() === '') {
        hasError = true;
        errors.value.push("Seleziona un tipo di file valido.");
      } else {
        errors.value.push("");
      }
    } else {
      if (!filenew.value[field] || filenew.value[field].toString().trim() === '') {
        hasError = true;
        errors.value.push(`${errorMessage}`);
      } else {
        errors.value.push("");
      }
    }
  });

  return !hasError;
}

let errorInvalidDate = ref('');
function validateDate() {
  const selectedDate = new Date(filenew.value.data_rilievo);
  const today = new Date();

  if (selectedDate > today) {
    errorInvalidDate.value =  'La data di inserimento non può essere successiva alla data odierna';
     filenew.value.data_rilievo = today;
  } else {
    errorInvalidDate.value = '';
  }
}
__expose({ openModal });

return (_ctx: any,_cache: any) => {
  return (showConfirm.value)
    ? (_openBlock(), _createBlock(_unref(Modal), {
        key: 0,
        size: "2xl",
        onClose: _cache[7] || (_cache[7] = ($event: any) => (handleUserInput(false)))
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t(alertConfirmMessage.value)), 1)
        ]),
        body: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("input", {
              onChange: _cache[0] || (_cache[0] = ($event: any) => (readFile($event))),
              class: "block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400",
              id: "file_input",
              type: "file",
              accept: (_ctx.schema === 'kardiasschema') ? '.pdf' : ''
            }, null, 40, _hoisted_4),
            _hoisted_5,
            _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(errors)[0]), 1),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(errorInvalidFile)), 1),
            _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("Data rilievo")), 1),
            _withDirectives(_createElementVNode("input", {
              type: "date",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(filenew).data_rilievo) = $event)),
              onChange: validateDate,
              class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
            }, null, 544), [
              [_vModelText, _unref(filenew).data_rilievo]
            ]),
            _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(errors)[1]), 1),
            _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(errorInvalidDate)), 1),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("file tipo")), 1),
              _withDirectives(_createElementVNode("select", {
                id: "type",
                name: "type",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(filenew).type) = $event)),
                onChange: validateFields,
                class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
              }, [
                _createElementVNode("option", _hoisted_13, _toDisplayString(_ctx.$t("Seleziona un tipo di file")), 1),
                (_ctx.schema === 'fileschema')
                  ? (_openBlock(), _createElementBlock("option", _hoisted_14, _toDisplayString(_ctx.$t("Foto")), 1))
                  : _createCommentVNode("", true),
                (_ctx.schema === 'fileschema')
                  ? (_openBlock(), _createElementBlock("option", _hoisted_15, _toDisplayString(_ctx.$t("Video")), 1))
                  : _createCommentVNode("", true),
                (_ctx.schema === 'fileschema')
                  ? (_openBlock(), _createElementBlock("option", _hoisted_16, _toDisplayString(_ctx.$t("Registrazione")), 1))
                  : _createCommentVNode("", true),
                (_ctx.schema === 'fileschema')
                  ? (_openBlock(), _createElementBlock("option", _hoisted_17, _toDisplayString(_ctx.$t("Video Esami Strumentali")), 1))
                  : _createCommentVNode("", true),
                (_ctx.schema === 'fileschema')
                  ? (_openBlock(), _createElementBlock("option", _hoisted_18, _toDisplayString(_ctx.$t("Immagine Dicom")), 1))
                  : _createCommentVNode("", true),
                (_ctx.schema === 'fileschema')
                  ? (_openBlock(), _createElementBlock("option", _hoisted_19, _toDisplayString(_ctx.$t("Documento")), 1))
                  : _createCommentVNode("", true),
                (_ctx.schema == 'kardiasschema')
                  ? (_openBlock(), _createElementBlock("option", _hoisted_20, _toDisplayString(_ctx.$t("Kardia")), 1))
                  : _createCommentVNode("", true)
              ], 544), [
                [_vModelSelect, _unref(filenew).type]
              ]),
              _createElementVNode("p", _hoisted_21, _toDisplayString(_unref(errors)[2]), 1)
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t("Note")), 1),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(filenew).file_commento) = $event)),
                class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
              }, null, 512), [
                [_vModelText, _unref(filenew).file_commento]
              ]),
              _createElementVNode("p", _hoisted_23, _toDisplayString(_unref(errors)[3]), 1)
            ]),
            _createElementVNode("div", _hoisted_24, [
              (_unref(filenew).id_file == null)
                ? (_openBlock(), _createElementBlock("label", _hoisted_25, _toDisplayString(_ctx.$t(" Livello di confidenzialità * ")), 1))
                : _createCommentVNode("", true),
              (_unref(filenew).id_file == null)
                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                    key: 1,
                    id: "confidenzialità",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(filenew).id_livello_confidenzialita) = $event)),
                    class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(patient).liveli_confidencialita, (item, key) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: item.id_livello_confidenzialita,
                        key: key
                      }, _toDisplayString(item.confidenzialita_descrizione), 9, _hoisted_26))
                    }), 128))
                  ], 512)), [
                    [_vModelSelect, _unref(filenew).id_livello_confidenzialita]
                  ])
                : _createCommentVNode("", true),
              _createElementVNode("p", _hoisted_27, _toDisplayString(_unref(errors)[4]), 1)
            ])
          ])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("button", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (handleUserInput(false))),
              type: "button",
              class: "text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
            }, _toDisplayString(_ctx.$t("Annulla")), 1),
            _createElementVNode("button", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (handleUserInput(true))),
              type: "button",
              class: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            }, _toDisplayString(_ctx.$t("Invia")), 1)
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})